import React from "react";

import LinearProgress from "@busbud/design-system-components/dist/LinearProgress";
import { Label } from "@busbud/horizon";

import { Rating } from "@app/components/rating/rating";

import { useStyles } from "./ratings-breakdown.styles";

export const RatingProgress = ({
  star_count,
  rating_count,
  rating_percentage
}: {
  star_count: number;
  rating_count: number;
  rating_percentage: number;
}) => {
  const { classes } = useStyles();

  return (
    <div className="flex items-center gap-100">
      <div className="flex flex-nowrap">
        <Rating rating={star_count} total_reviews={rating_count} size="sm" />
        <Label
          className="min-w-400 text-color-secondary"
          as="span"
          size="xxs"
        >{`(${rating_count})`}</Label>
      </div>
      <LinearProgress
        size="sm"
        color="primary"
        value={Math.round(rating_percentage * 100)}
        variant="determinate"
        className={classes.ratingProgressBar}
      />
    </div>
  );
};
